import { api, authApi } from "@/lib/api";

const urlB64ToUint8Array = (base64) => {
  const padding = "=".repeat((4 - (base64.length % 4)) % 4);
  const normalized = (base64 + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = atob(normalized);
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
};

export const pushSupported = () =>
  "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;

export const registerServiceWorker = async () => {
  if (!("serviceWorker" in navigator)) return null;
  return navigator.serviceWorker.register("/service-worker.js", { scope: "/", updateViaCache: "none" });
};

export const getPushState = async () => {
  if (!pushSupported()) return { supported: false, subscribed: false, permission: "unsupported" };
  const reg = await navigator.serviceWorker.ready;
  const sub = await reg.pushManager.getSubscription();
  return { supported: true, subscribed: !!sub, permission: Notification.permission };
};

export const enablePush = async (subscribePath = "/push/subscribe") => {
  if (!pushSupported()) throw new Error("Tento prehliadač nepodporuje notifikácie.");
  const reg = await navigator.serviceWorker.ready;
  const permission = await Notification.requestPermission();
  if (permission !== "granted") throw new Error("Povolenie na notifikácie nebolo udelené.");

  const { data } = await api.get("/push/vapid-public-key");
  if (!data.key) throw new Error("Server nemá nastavené VAPID kľúče.");

  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlB64ToUint8Array(data.key),
    });
  }
  const json = sub.toJSON();
  await authApi().post(subscribePath, { endpoint: json.endpoint, keys: json.keys });
  return true;
};

export const disablePush = async (unsubscribePath = "/push/unsubscribe") => {
  const reg = await navigator.serviceWorker.ready;
  const sub = await reg.pushManager.getSubscription();
  if (sub) {
    await authApi().post(unsubscribePath, { endpoint: sub.endpoint }).catch(() => {});
    await sub.unsubscribe();
  }
  return true;
};

export const sendTestPush = async () => {
  await authApi().post("/push/test", {});
  return true;
};
